<template>
    <v-row>
        <div class="sidebar-value">
            <LinkButton
                :link="field.value"
            />
        </div>
    </v-row>
</template>

<script>
import LinkButton from "../../Global/Input/Button/LinkButton.vue";

export default {
    name: "LinkField",
    components: {LinkButton},
    props: {
        field: {
            type: Object,
            required: true
        }
    },
}

</script>

<style scoped lang="scss">
</style>